export const galleryData = [
  {
    title: "ORIENTATION SYNERGY",
    photos: [
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710099027/dlmzhmrac5ihhiqhh5be.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710142816/pvnxqy9ojme5i11reqgk.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710151940/sinxo018kcoqosfdneud.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710099033/dnvlimkmcrabdzyt5fb4.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710142815/zhoag0htke6cbzvtrgyz.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710099029/jnuvbbaqhtdu1nwqcmp0.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710142815/xcajmnjrwdne9or5xhcq.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710099028/exaac7dgc4c7glnxlujj.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710099040/q1ggi0ex9q89hpoejlfs.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710099054/kcg1ujavlfb3xbpu5xfw.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710142815/r42j7h7fmfdeaqtsyynn.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710152456/dbzakzs23fdzgopptw2u.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710142816/lulnonxf5ltr2xf6arxx.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710142817/yqkmibtiz6zslkq8rdkv.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710099027/pezyxc9sbp8ejlk8luhe.jpg",
    ],
  },
  {
    title: "RECRUITMENT",
    photos: [
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710151941/lxwbnz6zzyqwxvw5hcj7.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710151943/kxwxmpywmx6nlr362vpx.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710151950/f9079ixwhwmln7dnliw8.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710151956/psagsziqoescpgty5dey.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710151960/vxdms3ln8j1deptwzayz.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710151961/tsgtf9sd209j4aflhb0j.jpg",
      "https://res.cloudinary.com/dy0raom2p/image/upload/v1710151968/a8dap4sp9nx220qs3oa4.jpg",
    ],
  },
];
